var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.99 7.414c.012.157.012.313.012.47 0 4.768-3.63 10.262-10.263 10.262-2.044 0-3.942-.591-5.54-1.619.291.034.57.045.872.045 1.686 0 3.238-.57 4.478-1.541a3.61 3.61 0 0 1-3.373-2.502c.224.034.447.056.682.056.324 0 .647-.045.949-.123a3.61 3.61 0 0 1-2.892-3.54v-.045c.48.268 1.038.436 1.63.458a3.6 3.6 0 0 1-1.608-3.004c0-.67.179-1.284.491-1.82a10.25 10.25 0 0 0 7.438 3.775 4 4 0 0 1-.09-.827 3.606 3.606 0 0 1 3.608-3.607c1.038 0 1.976.436 2.635 1.14a7.1 7.1 0 0 0 2.29-.872 3.6 3.6 0 0 1-1.586 1.988A7.2 7.2 0 0 0 19.8 5.55a7.8 7.8 0 0 1-1.81 1.864"
  })));
};
export default SvgTwitter;